module.exports = __webpack_public_path__ + "img/step1-b.224c01e5.png";